<script lang="ts">
	import Minus from '$lib/icons/minus.svelte';
	import type { Snippet } from 'svelte';
	import { fade, slide } from 'svelte/transition';

	interface Props {
		title: string;
		open?: boolean;
		durationSlide?: number;
		durationFade?: number;
		ontoggle?: (open: boolean) => void;
		children?: Snippet;
	}

	let {
		title,
		open = false,
		durationSlide = 250,
		durationFade = 200,
		ontoggle,
		children
	}: Props = $props();

	function toggle() {
		open = !open;
		ontoggle?.(open);
	}
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<article
	class="cursor-pointer py-5 transition-colors duration-400 lg:py-8"
	onclick={toggle}
	onkeydown={(e) => {
		if (e.key === 'Enter') {
			toggle();
		}
	}}
	tabindex="0"
>
	<div class="flex flex-row items-start justify-between gap-x-4 lg:gap-x-1" aria-expanded={open}>
		<h1 class="flex-1 select-none text-[18px]/[140%] lg:text-[24px]">
			{title}
		</h1>
		<div class="relative h-8 w-8 max-lg:-mt-1 lg:mt-[1px]">
			<Minus class="absolute" />
			<Minus class="absolute transition-transform {open ? 'rotate-0' : '-rotate-90'}" />
		</div>
	</div>
	{#if open}
		<div transition:slide={{ duration: durationSlide }}>
			<div transition:fade={{ duration: durationFade }}>
				{@render children?.()}
			</div>
		</div>
	{/if}
</article>
